
export enum enumOrigin {
  Imported = 1,
  FICA,
  'Call Centre',
  FrontEnd,
  'Cellphone Registrastion',
  'FrontEnd In Process',
  'HQ Portal',
  MaxBank,
  'HQ Portal System',
  'Smart Swipe',
  WiCode,
  Universal
}

export namespace enumOrigin {
  export function values() {
    return Object.keys(enumOrigin).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
